// extracted by mini-css-extract-plugin
module.exports = {"accordions":"accordions__-Uo1D"};